var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('c-header',{attrs:{"no-actions":_vm.noActions}}),_c('v-main',{staticClass:"workspace"},[_c('router-view')],1),_c('c-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }